module.exports = __webpack_public_path__ + "img/send.431436ba.png";